import React, { lazy, Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import Loading from '../../components/Loading';

const DateLog = lazy(() => import('../../DateLog'));

const LogPage = props => {
  // useEffect(() => {
  //   User?.user?.posts?.refetch();
  // }, []);
  return (
    <Suspense fallback={<Loading />}>
      <DateLog />
    </Suspense>
  );
};

LogPage.propTypes = {

};

export default observer(LogPage);
